"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DECIDING_EVIDENCE_VOTER_TIERS_DESCENDING = exports.EvidenceVoterTierSchema = exports.EvidenceVoterTier = void 0;
exports.classifyVoterTier = classifyVoterTier;
const z = require("zod");
const authentication_types_1 = require("../Auth/authentication.types");
const reviewer_role_1 = require("../Auth/reviewer-role");
var EvidenceVoterTier;
(function (EvidenceVoterTier) {
    EvidenceVoterTier["Pipeline"] = "pipeline";
    EvidenceVoterTier["Trainee"] = "trainee";
    EvidenceVoterTier["GeneralUser"] = "general_user";
    EvidenceVoterTier["GeneralReviewer"] = "general_reviewer";
    EvidenceVoterTier["SeniorReviewer"] = "senior_reviewer";
    EvidenceVoterTier["ExpertReviewer"] = "expert_reviewer";
    EvidenceVoterTier["AdminReviewer"] = "admin_reviewer";
})(EvidenceVoterTier || (exports.EvidenceVoterTier = EvidenceVoterTier = {}));
exports.EvidenceVoterTierSchema = z.nativeEnum(EvidenceVoterTier);
exports.DECIDING_EVIDENCE_VOTER_TIERS_DESCENDING = [
    EvidenceVoterTier.AdminReviewer,
    EvidenceVoterTier.ExpertReviewer,
    EvidenceVoterTier.SeniorReviewer,
    EvidenceVoterTier.GeneralReviewer,
    EvidenceVoterTier.GeneralUser,
];
function classifyVoterTier(standing) {
    if (standing.isStaff) {
        return EvidenceVoterTier.AdminReviewer;
    }
    if (standing.reviewerRole === reviewer_role_1.ReviewerRole.Expert) {
        return EvidenceVoterTier.ExpertReviewer;
    }
    if (standing.reviewerRole === reviewer_role_1.ReviewerRole.Senior) {
        return EvidenceVoterTier.SeniorReviewer;
    }
    if (standing.memberships.some((m) => m.role === authentication_types_1.MembershipRole.Trainee)) {
        return EvidenceVoterTier.Trainee;
    }
    if (standing.holdsReviewerCapability) {
        return EvidenceVoterTier.GeneralReviewer;
    }
    return EvidenceVoterTier.GeneralUser;
}
//# sourceMappingURL=evidence-voter-tier.js.map